<script lang="ts">
	import Tooltip from '$lib/tooltip/Tooltip.svelte';
	import { getNumBackInUnits, trimString } from '$lib/util/util';
	import { margin, userMarginBalanceForTrade } from '../userInteract/store';
	import { smartContractWalletAddress, smartWalletName } from './store';

	export let openMenu: () => void;
</script>

<Tooltip
	title="You can click here to deposit more margin or add more authority. You can increase your current margin by depositing more margin. Total capital for trade is used when you enter a amount in margin input automatically. Capital allowed for trade is taken from your smart wallet and margin in markets without a position."
	header="Current margin in selected market / Capital allowed for trade"
>
	<button
		class="border border-fx-grey-600 bg-fx-gradient-8 px-2 pt-2 pb-1 rounded-lg squircle-lg text-fx-grey-200 text-sm flex gap-1 justify-center items-center"
		on:click={openMenu}
	>
		<img src={'scwallet/wallet-header.svg'} loading="lazy" class="w-5" alt="wallet" />
		<span class="sm:hidden"> {trimString($smartWalletName, 5)} </span>
		<span class="sm:block hidden"> {$smartWalletName} </span>

		<div class="text-fx-blue font-semibold text-sm">
			{#if $smartContractWalletAddress && $userMarginBalanceForTrade}
				${getNumBackInUnits($margin, 18, 2)}
				<span class="text-fx-grey-500"> / </span>

				${getNumBackInUnits($userMarginBalanceForTrade, 18, 2)}
			{:else}
				<div
					class="animate-pulse bg-fx-grey-800 h-5 col-span-2 rounded-lg squircle-lg w-4 mx-auto"
				/>
			{/if}
		</div>
	</button>
</Tooltip>
